import React from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import "../Useful/useful.css";
import AddSetting from "../AdsCategory/Add_Category";
import "./setting.css";
import Addimage from "../../../src/image-add.png";
import { ModalDetail } from "../Useful/Useful";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  CategoryGet,
  CategoryCreate,
  CategoryDelete,
  CategoryGetById,
  CategoryUpdate,
  UploadFile,
} from "../../fetch";

export default class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      existData: {},
      error: null,
      data: [],
      isAdd: true,
      isEdit: false,
      page: 0,
      rowsPerPage: 20,
      loading: false,
      datalength: 0,
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  getList = () => {
    this.setState({ loading: true });
    CategoryGet(this.state.page, this.state.rowsPerPage)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false });
          this.setState({ data: response.result, datalength: response.count });
        } else {
          console.log(response.message);
          this.setState({ loading: true });
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: true });
        toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
      });
  };

  onFormSubmit(data) {
    if (data.name === "") {
      toast.error(" نام دسته بندی وارد نشده است");

      return false;
    }

    if (data.id !== "") {
      CategoryUpdate(data)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          var query = this.state.data.find((q) => q.id === data.id);
          query.name = data.name;

          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          return null;
        });
    } else {
      data.id = "";
      CategoryCreate(data)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.setState((prevState) => ({
            data: [...prevState.data, response.result],
          }));
          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
          return null;
        });
    }
  }

  handleDelete = (id) => {
    if (id === "") {
      toast.warn("شناسه ای برای ادامه عملیات وجود ندارد");
      return;
    }
    confirmAlert({
      title: "توجه",
      message: "اطلاعات مورد نظر حذف خواهد شد",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            CategoryDelete(id)
              .then((response) => {
                this.setState({
                  data: this.state.data.filter((item) => item.id !== id),
                });
                toast.success("اطلاعات مورد نظر حذف شد");
                return null;
              })
              .catch((error) => {
                console.log(error);
                toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
                return null;
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getList();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getList();
    });
  };

  render() {
    let setForm;
    if (this.state.isAdd || this.state.isEdit) {
      setForm = (
        <AddSetting
          onFormSubmit={this.onFormSubmit}
          fillData={this.state.existData}
        />
      );
    }

    return (
      <div>
        {setForm}
        <hr />
        <div className="col-lg-12  mypanel shadow">
          <Header_panel
            title="لیست دسته بندی ها"
            idMenu="#navbarToggleExternalContentSettingList"
          />
          <div className="pos-f-t">
            <div
              className="collapse"
              id="navbarToggleExternalContentSettingList"
            >
              <div className="p-4 mytable">
                <table className="table table-striped rtltable">
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>نام دسته بندی</th>

                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>

                        <td>{item.name}</td>

                        <td>
                          <ModalUpdate
                            buttonLabel="ویرایش"
                            title="ویرایش"
                            id={item.id}
                            onFormSubmit={this.onFormSubmit}
                          ></ModalUpdate>{" "}
                        </td>
                        <td>
                          {" "}
                          <Button
                            color="warning"
                            id="regDelbtn"
                            onClick={() => {
                              this.handleDelete(item.id);
                            }}
                          >
                            حذف
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {this.state.loading && (
          <CircularProgress size={30} className="buttonProgress" />
        )}
        <TablePagination
          // style={{ direction: "rtl" }}
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={this.state.datalength}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          labelRowsPerPage="تعداد نمایش :"
          nextIconButtonText="بعدی"
          backIconButtonText="قبلی"
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export class ModalUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      name: "",
      id: "",
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {
    CategoryGetById(this.props.id)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.setState({ name: response.result.name });
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  toggle() {
    this.setState({ modal: !this.state.modal, id: this.props.id });
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSubmit(event) {
    event.preventDefault();
    this.props.onFormSubmit(this.state);
    this.setState({ id: "", name: "" });
  }

  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <Form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
            <ModalBody style={{ textAlign: "right" }}>
              <div className="row p-4">
                <div className="col-lg-12"></div>
                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="name">
                      * نام دسته بندی
                    </label>
                    <input
                      value={this.state.name}
                      onChange={this.handleChange("name")}
                      className="contactInput form-control"
                      name="name"
                      placeholder="نام دسته بندی..."
                    />
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle}>
                بستن
              </Button>
              <Button
                type="submit"
                color="primary"
                id="regProdbtn"
                onClick={this.toggle}
              >
                ذخیره
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}
